import React, { useContext, useEffect, useState } from "react";
import { Select, DatePicker, Space, Button, Card, Tooltip, Row } from "antd";
import dayjs, { Dayjs } from "dayjs";
import { FileProps } from "../../interfaces/interfaces"; // adjust the path if needed
import DataContext from "../../context/DataContext";
import { useNavigate, useParams } from "react-router-dom";
import { FilesTable } from "../../components/customer";
import { ColumnComponent } from "../../components/ui";
import { UploadOutlined } from "@ant-design/icons";
import { FileUploadModalClient } from "../../components/customer/files/FileUploadModalClient";
import AuthContext from "../../context/AuthContext";
import { filterOption } from "../../utils/func/utils";

const { RangePicker } = DatePicker;

export const FileManagerClient: React.FC = () => {
  const navigate = useNavigate();
  const { idClient, idCustomer } = useParams();
  const {
    projectList,
    dataLoading,
    customerFiles: files,
    getDataById,
  } = useContext(DataContext);
  const { profileInfo } = useContext(AuthContext);
  const [filterProject, setFilterProject] = useState<string | undefined>();
  const [filterDateRange, setFilterDateRange] = useState<[Dayjs, Dayjs] | null>(
    null,
  );
  const [isModalFileUploadVisible, setIsModalFileUploadVisible] =
    useState(false);
  const [filesFilter, setFilesFilter] = useState<any>({
    active: true,
    search: undefined,
  });

  useEffect(() => {
    if (idCustomer === "undefined") {
      let id =
        profileInfo?.customers && profileInfo?.customers.length > 0
          ? profileInfo?.customers[0]
          : "";
      if (id) {
        navigate(`/client-files/${idClient}/${id}`);
      }
    }
  }, [idCustomer, profileInfo]);

  useEffect(() => {
    if (idClient && idCustomer && idCustomer !== "undefined") {
      let { search, ...filters } = filesFilter;
      getDataById({
        endpoint: `customer-files/${idClient}/${idCustomer}`,
        type: "customer-files",
        filters: {
          customer: idCustomer,
          ...filters,
        },
        search: search,
      });
    }
  }, [idClient, idCustomer, filesFilter]);

  useEffect(() => {
    if (filterProject) {
      setFilesFilter((prev: any) => ({
        ...prev,
        project: filterProject,
      }));
    } else {
      setFilesFilter((prev: any) => ({
        ...prev,
        project: undefined,
      }));
    }

    if (filterDateRange) {
      const [start, end] = filterDateRange;
      const startOfDay = start.startOf("day");
      const endOfDay = end.endOf("day");
      setFilesFilter((prev: any) => ({
        ...prev,
        uploadDate: {
          $gte: startOfDay.toISOString(),
          $lte: endOfDay.toISOString(),
        },
      }));
    } else {
      setFilesFilter((prev: any) => ({
        ...prev,
        uploadDate: undefined,
      }));
    }
  }, [filterProject, filterDateRange]);

  return (
    <>
      <Row gutter={[24, 0]}>
        <ColumnComponent>
          <Card
            className="summary-client__card"
            styles={{ body: { display: "none" } }}
            actions={[
              <Space direction="vertical" size={0} style={{ width: "100%" }}>
                <label>Projects</label>
                <Select
                  filterOption={filterOption}
                  showSearch
                  placeholder="Filter by Project"
                  style={{ width: "90%" }}
                  onChange={setFilterProject}
                  allowClear
                  options={projectList.map((project) => ({
                    label: project.name,
                    value: project._id,
                  }))}
                ></Select>
              </Space>,

              <Space direction="vertical" size={0} style={{ width: "100%" }}>
                <label>Filter By Date</label>
                <RangePicker
                  style={{ width: "90%" }}
                  format="MM/DD/YYYY"
                  allowClear
                  onChange={(range) =>
                    setFilterDateRange(range as [Dayjs, Dayjs])
                  }
                />
              </Space>,
              <Space direction="vertical" size={0} style={{ width: "100%" }}>
                <label>Actions</label>
                <Space direction="horizontal" size={0}>
                  <Tooltip title="Upload File" placement="bottom">
                    <Button
                      type="link"
                      icon={<UploadOutlined />}
                      loading={dataLoading}
                      onClick={() => setIsModalFileUploadVisible(true)}
                    >
                      New File
                    </Button>
                  </Tooltip>
                </Space>
              </Space>,
            ]}
          ></Card>
        </ColumnComponent>
        <ColumnComponent>
          <FilesTable
            idClient={idClient || ""}
            files={files}
            onChangePage={(current, pageSize) => {
              setFilesFilter((prev: any) => ({
                ...prev,
                page: current,
                perPage: pageSize,
              }));
            }}
          />
        </ColumnComponent>
      </Row>
      <FileUploadModalClient
        open={isModalFileUploadVisible}
        idClient={idClient || ""}
        idCustomer={idCustomer || ""}
        onClose={() => setIsModalFileUploadVisible(false)}
        onUploadSuccess={() =>
          idClient &&
          getDataById({
            endpoint: `customer-files/${idClient}/${idCustomer}`,
            type: "customer-files",
          })
        }
      />
    </>
  );
};
